import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Component Imports
import { AuthProvider } from './contexts/AuthContext';
import { PublisherAuthProvider } from './contexts/PublisherAuthContext';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import ProfilePage from './components/ProfilePage';
import TokenPurchasePage from './components/TokenPurchasePage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminPage from './components/AdminPage';
import PublisherDashboard from './components/PublisherDashboard';
import ApiDocsPage from './components/ApiDocsPage';
import PublisherLoginPage from './components/PublisherLoginPage';
import PublisherRegisterPage from './components/PublisherRegisterPage';
import PublisherProtectedRoute from './components/PublisherProtectedRoute';

// Use environment variables for keys
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function App() {
  return (
    <Router>
      <AuthProvider> { /* For Client Users */ }
        <PublisherAuthProvider> { /* For Publisher Users */ }
          <Elements stripe={stripePromise}>
            <div className="flex flex-col min-h-screen bg-wp-bg">
              <Navbar />
              <main className="flex-grow">
                <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                  <Routes>
                    {/* Client-facing Routes */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                    <Route path="/buy-tokens" element={<ProtectedRoute><TokenPurchasePage /></ProtectedRoute>} />
                    <Route path="/docs" element={<ApiDocsPage />} />
                    <Route path="/admin" element={<AdminProtectedRoute><AdminPage /></AdminProtectedRoute>} />

                    {/* Publisher-facing Routes */}
                    <Route path="/publisher/login" element={<PublisherLoginPage />} />
                    <Route path="/publisher/register" element={<PublisherRegisterPage />} />
                    <Route path="/publisher/dashboard" element={<PublisherProtectedRoute><PublisherDashboard /></PublisherProtectedRoute>} />
                  </Routes>
                </div>
              </main>
              <Footer />
            </div>
          </Elements>
        </PublisherAuthProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
